'use strict';

var invoke = require('../utils/invoke');

module.exports = invoke('toUpperCase');


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/string/upperCase.js
// module id = 2207
// module chunks = 37